var map = {
	"./facebook-icon.svg": 889,
	"./facebook.svg": 890,
	"./icons8-instagram-16.svg": 891,
	"./icons8-instagram.svg": 892,
	"./instagram-icon.svg": 893,
	"./instagram-icon.webp": 894,
	"./instagram.svg": 895,
	"./linkedin.svg": 896,
	"./pinterest.svg": 897,
	"./sprite.svg": 249,
	"./telegram.svg": 898,
	"./tiktok.svg": 899,
	"./twiter.svg": 900,
	"./twitter.svg": 901,
	"./viber.svg": 902,
	"./want-to-order-icon.svg": 903,
	"./wats-up-icn.svg": 904,
	"./youtube.svg": 905
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 888;